const schema = {
  title: {
    type: 'text',
    label: 'Video Title',
    placeholder: 'Enter title',
    required: true,
    info: true,
    character_count: 250,
    disabled: true
  },
  video_url: {
    type: 'text',
    label: 'Video URL',
    placeholder: '',
    required: false,
    info: true,
  },
  featured_video: {
    type: 'toggle',
    label: 'Featured Video',
    placeholder: '',
    required: false,
    info: true,
  }
};

const pcnCategories = ['EMIS'];

const video = [
    {
        id: "videoid1",
        videoUrl: 'https://www.youtube.com/watch?v=KSM0lLbVYOo',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020',
        active: true,
        featured: true
    },
    {
      id: "videoid2",
      videoUrl: 'https://www.youtube.com/watch?v=7E0fVfectDo',
      title: 'Optimising your EMIS Web configurations',
      date: '07 Sep 2020',
      active: true,
      featured: true
    },
    {
      id: "videoid3",
      videoUrl: 'https://www.youtube.com/watch?v=nhDdn86AoXs',
      title: 'Optimising your EMIS Web configurations',
      date: '07 Sep 2020',
      active: true,
      featured: false
    },
    {
      id: "videoid4",
      videoUrl: 'https://www.youtube.com/watch?v=W85oD8FEF78',
      title: 'Optimising your EMIS Web configurations',
      date: '07 Sep 2020',
      active: false,
      featured: true
    },
    {
      id: "videoid5",
      videoUrl: 'https://www.youtube.com/watch?v=NpKpCeUQx2w',
      title: 'Optimising your EMIS Web configurations',
      date: '07 Sep 2020',
      active: true,
      featured: true
    },
    {
      id: "videoid6",
      videoUrl: 'https://www.youtube.com/watch?v=kUubW5szdwA',
      title: 'Optimising your EMIS Web configurations',
      date: '07 Sep 2020',
      active: true,
      featured: true
    },
    {
      id: "videoid7",
      videoUrl: 'https://www.youtube.com/watch?v=DXP1KdZX4io',
      title: 'Optimising your EMIS Web configurations',
      date: '07 Sep 2020',
      active: false,
      featured: false
    },
    {
      id: "videoid8",
      videoUrl: 'https://www.youtube.com/watch?v=Q0oIoR9mLwc',
      title: 'Optimising your EMIS Web configurations',
      date: '07 Sep 2020',
      active: true,
      featured: true
    }
];


export { schema, video, pcnCategories };